<div class="row productLabelFormPage">
  <div class="mainContent">

    <div class="row justify-content-start align-items-center py-2 m-0 mt-1">
      <h3>
        Convert/Reconcile Reservation
      </h3>
    </div>
    <div class="OrderReleaseTop" *ngIf="reservationData">

      <div class="row">
        <div class="col-md-4 withBordr productLabelAccountName pb-3 pb-md-0">

          <h3 class="headerContent">Account:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.shipToName}}
            </h4>
            <p class="address m-0">
              {{reservationData.shipToAccountAddress1}}, {{reservationData.shipToCity}}, {{reservationData.shipToState}} - {{reservationData.shipToZipCode}}
            </p>
            <p class="phoneNo m-0">
              {{reservationData.shipToContact}}
            </p>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Account #: {{reservationData.shipTo}}
              </span>
            </p>
          </div>

        </div>

        <div class="col-md-4 material-select withBordr productLabelAccountName pb-3 pb-md-0">
          <h3 class="headerContent">Seller:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.salesRepresentativeAccountName}}
            </h4>
            <p class="phoneNo m-0">
              {{reservationData.salesRepresentativeContact}}
            </p>
            <p class="grower-nos m-0">
              <span class="email">
                {{reservationData.salesRepresentativeEmail}}
              </span>
            </p>
          </div>
        </div>
        <div class="col-md-4 material-select withBordr productLabelAccountName">
          <h3 class="headerContent">Grower:</h3>
          <div class="col-md-12 p-0">
            <h4 class="name greenColor">
              {{reservationData.growerName}}
            </h4>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Retail Account ID: {{reservationData.retailAccountId}}
              </span>
            </p>
            <h4 class="name greenColor">
              {{reservationData.retaileAccountName}}
            </h4>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                Email: {{reservationData.retailerEmail}}
              </span>
            </p>
            <p class="grower-nos m-0">
              <span class="grower-gln">
                GMK: {{reservationData.gmk}}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center flex-md-row flex-column-reverse">
      <div class="productsection d-flex align-items-center" [ngStyle]="!readOnlyAccess && selectedCount > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
      </div>
      <div class="d-flex justify-content-end">
        <span [matTooltip]="tooltipMessage" matTooltipPosition="above">
          <button class="btns addReservation mr-3" [disabled]="!enableHybridLevelButton || !isConversionEligible" mat-raised-button color="primary" (click)="OpenAddHybridProductSlider()">
            Convert Reservation at Hybrid/Variety & Package Level
          </button>
        </span>
        <span [matTooltip]="tooltipMessage" matTooltipPosition="above">
          <button class="btns addReservation" [disabled]="!enableItemLevelButton || !isConversionEligible" mat-raised-button color="primary" (click)="OpenAddProductSlider()">
            Convert Reservation at Product Level
          </button>
        </span>
      </div>
    </div>
    <div class="tableOuterContainer">
      <table mat-table [dataSource]="seedReservationDataSource" multiTemplateDataRows class="productTable matTables seedReservationTable">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>  </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox #SingleCheck class="custom-checkbox"
                          [style.display]="'contents'"
                          (change)="enableCheckBoxSingle(SingleCheck._checked,element)"
                          [(ngModel)]="element.selected"
                          [attr.data-testid]="'ddl-specific-check_'+i"
                          [disabled]="!isConversionEligible"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="productLine">
          <th mat-header-cell *matHeaderCellDef> Product Line </th>
          <td mat-cell *matCellDef="let element">

            <p class="d-block d-md-none fontSize mb-2">Product Line</p>
            <span *ngIf="element.productLineName && element.marketingBrandName">
              {{ element.productLineName }}
            </span>

            <ng-select *ngIf="!element.productLineName"
                       [items]="productList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess"
                       bindValue="id"
                       [placeholder]="element.productLineId ? '' : 'Select Product Line'"
                       [(ngModel)]="element.productLineId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'productLine')">
            </ng-select>
            <div *ngIf="element.hasProductLineError" class="text-danger large">
              Please select Product Line
            </div>
          </td>

        </ng-container>
        <ng-container matColumnDef="marketingBrand">
          <th mat-header-cell *matHeaderCellDef> Marketing Brand </th>
          <td mat-cell *matCellDef="let element">

            <p class="d-block d-md-none fontSize mb-2">Marketing Brand</p>

            <span *ngIf="element.marketingBrandName && element.productLineName">
              {{ element.marketingBrandName }}
            </span>

            <ng-select *ngIf="!element.marketingBrandName"
                       [items]="element.marketingBrandFilteredList"
                       class="custom-select-grower grower-add-drop productLabelDropdown"
                       [virtualScroll]="true"
                       bindLabel="value"
                       [disabled]="readOnlyAccess || !element.productLineId"
                       bindValue="id"
                       [placeholder]="element.marketingBrandId ? '' : 'Select Marketing Brand'"
                       [(ngModel)]="element.marketingBrandId"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="onProductOrBrandChange(element, 'marketingBrand')">
            </ng-select>
            <div *ngIf="element.hasMarketingBrandError" class="text-danger large">
              Please select Marketing Brand
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="reservationUnits">
          <th mat-header-cell *matHeaderCellDef> Reservation Units </th>
          <td mat-cell *matCellDef="let element" class="reservation-units-cell">
            <div class="d-flex align-items-center justify-content-center">
              <span *ngIf="reservationData.isParentChildGMK" class="info-tooltip">
                <i class="fas info-tooltip__icon" aria-hidden="true">i</i>

                <div class="info-tooltip__panel" role="tooltip">
                  <div class="info-tooltip__header">
                    <div class="info-tooltip__col info-tooltip__col--grower">Grower</div>
                    <div class="info-tooltip__col info-tooltip__col--center">Reservation Units</div>
                    <div class="info-tooltip__col info-tooltip__col--center">Grower Units</div>
                  </div>

                  <!-- ✅ Loop through grower reservation summary for tooltip -->
                  <ng-container *ngIf="element.growerReservationOrders && element.growerReservationOrders.length > 0; else noTooltipData">
                    <div class="info-tooltip__row" *ngFor="let detail of element.growerReservationOrders">
                      <div class="info-tooltip__grower">
                        <div class="info-tooltip__grower-name">{{ detail.growerName }}</div>
                        <div class="info-tooltip__grower-address">{{ detail.growerAddress }}</div>
                      </div>

                      <div class="info-tooltip__value info-tooltip__value--center">
                        {{ detail.reservationUnits }}
                      </div>

                      <div class="info-tooltip__value info-tooltip__value--center">
                        {{ detail.growerUnits }}
                      </div>
                    </div>
                  </ng-container>

                  <!-- ✅ No data template -->
                  <ng-template #noTooltipData>
                    <div class="info-tooltip__row">
                      <div class="info-tooltip__col" colspan="3" style="text-align: center; padding: 10px;">
                        No grower order activity found
                      </div>
                    </div>
                  </ng-template>
                </div>
              </span>
              <p class="d-block d-md-none fontSize mb-2">{{ element.reservationUnits }}</p>
              <div class="ml-2">
                <input [readonly]="readOnlyAccess || (!element.newLine && !element.selected)"
                       type="text"
                       class="geu-txt decimal-txt unitsText largeTableTxt"
                       (keyup)="quantityTextChange(element)"
                       [(ngModel)]="element.reservationUnits"
                       maxlength="6"
                       appNumbersOnly
                       [attr.data-testid]="'txt-specific-qty_'+i" />
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Grower Units -->
        <ng-container matColumnDef="growerUnits">
          <th mat-header-cell *matHeaderCellDef class="expandCol">Grower Units</th>
          <td mat-cell *matCellDef="let element" class="expandCol">
            <p class="d-block d-md-none fontSize mb-2">{{ element.growerUnits }}</p>
            <span class="d-none d-md-inline">{{ element.growerUnits }}</span>
            <span (click)="toggleExpandRow(element); $event.stopPropagation();" [attr.data-testid]="'btn-expand_'+element.productLineId">
              <i class="fas" [ngClass]="expandedElement === element ? 'fa-minus' : 'fa-plus'"></i>
            </span>
          </td>
        </ng-container>

        <!-- Long / Short -->
        <ng-container matColumnDef="longShort">
          <th mat-header-cell *matHeaderCellDef> Long/ (Short) </th>
          <td mat-cell *matCellDef="let element">
            <!--<p class="d-block d-md-none fontSize mb-2">{{ element.longUnits }}</p>
      <span class="d-none d-md-inline">{{ element.longUnits }}</span>-->
            <span *ngIf="element.longUnits>=0" class="text-center">{{commonService.getFormatedNumber(element.longUnits) | number}}</span>
            <span *ngIf="element.longUnits<0" class="text-center oval-shape treatment"> ({{commonService.getFormatedNumber(element.longUnits | positiveValue) | number}})</span>
          </td>
        </ng-container>

        <!-- Pending Reservation Units -->
        <ng-container matColumnDef="pendingReservtionUnits">
          <th mat-header-cell *matHeaderCellDef> Pending Reservation Units </th>
          <td mat-cell *matCellDef="let element">
            <p class="d-block d-md-none fontSize mb-2">{{ element.pendingReservationUnits }}</p>
            <span class="d-none d-md-inline">{{ element.pendingReservationUnits }}</span>
          </td>
        </ng-container>

        <!-- Expanded Detail Row -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-detail-cell">
            <div class="expanded-detail-content" *ngIf="element === expandedElement">
              <div class="expanded-row-inner">
                <table class="grower-detail-table">
                  <thead>
                    <tr>
                      <th>Grower Details</th>
                      <th>Grower Units</th>
                      <th>Order</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="element.growerDetails && element.growerDetails.length > 0; else noGrowerDetails">
                      <tr *ngFor="let detail of (element.showAllGrowerDetails ? element.growerDetails : element.growerDetails.slice(0, 2))">
                        <td>
                          {{ detail.growerName }}
                          <span class="growerDetails">{{detail.growerAddress}}</span>
                        </td>
                        <td class="growerDetails">{{ detail.growerUnits }}</td>
                        <td>
                          <a *ngIf="detail.isClickable"
                             class="view-order-link"
                             (click)="redirectToOrder(detail)"
                             data-testid="btn-view-grower-order">
                            {{ detail.orderNumber }}
                          </a>
                          <!-- AC 4: Partner orders - non-clickable plain text -->
                          <span *ngIf="!detail.isClickable">
                            {{ detail.orderNumber }}
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-template #noGrowerDetails>
                      <tr>
                        <td colspan="3" class="no-data-cell">No grower order activity found for this reservation line.</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
                <div class="p-2 d-flex align-items-center justify-content-end">
                  <span class="growerDetails mr-4">Grower Totals : {{element.growerDetails.length}}</span>
                  <div class="view-all-toggle" *ngIf="element.growerDetails && element.growerDetails.length > 2">
                    <button mat-raised-button class="btns mat-raised-button wide-100" (click)="toggleShowAllGrowerDetails(element)">
                      {{ element.showAllGrowerDetails ? 'Show Less' : 'View All (' + element.growerDetails.length + ')' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Inline Error Message (similar to CPP) -->
            <div class="inline-error red-inline-error" *ngIf="element.hasError" id="error_{{element.seedReservationDetailId}}">
              <div class="row">
                <div class="col-md-12">
                  <div class="error-msg" [attr.data-testid]="'lbl-error-message_'+element.productLineId+'_'+element.marketingBrandId">
                    <p class="m-0 text-center">{{element.errorMessage}}</p>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.expanded-row]="expandedElement === row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
    </div>
  </div>

  <div class="SeedFulfillBtnSec">

    <div class="row d-flex align-items-center flex-md-row flex-column-reverse">
      <div class="col-md-8 col-12 p-1 d-flex d-md-block">
        <button mat-raised-button class="btns backBtn" color="primary" (click)="navigateTolandingPage()">Back to Reservation Inquiry</button>
      </div>
    </div>
  </div>
</div>
